import { Component, TemplateRef, ViewChild } from '@angular/core';
import { SpinnerComponent } from "../../layout/spinner/spinner.component";
import { CommonModule } from '@angular/common';
import { LanguageService } from 'src/app/services/language/language.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GalleryService } from 'src/app/services/gallery/gallery.service';
import { CdkDragDrop, DragDropModule, moveItemInArray } from '@angular/cdk/drag-drop';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { environment } from '../../../../environments/environment'
import { UploadComponent } from "../../layout/upload/upload.component";

import { EditorModule } from '@tinymce/tinymce-angular';
import 'tinymce/tinymce.min.js';                    
import 'tinymce/icons/default/icons.min.js';
import 'tinymce/themes/silver/theme.min.js'; 

// საჭიროებისამებრ პლაგინები
import 'tinymce/plugins/link';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/image';
import 'tinymce/plugins/fullscreen';
@Component({
  selector: 'app-slider',
  imports: [SpinnerComponent, CommonModule, DragDropModule, ReactiveFormsModule, UploadComponent, EditorModule],
  templateUrl: './slider.component.html',
  styleUrl: './slider.component.css'
})
export class SliderComponent {

  load = false
  data: any
  error = false

  loadDeleteId: number | null = null;

  isEdit = false
  editBtnLoad = false
  @ViewChild('formModal') formModalTemplate!: TemplateRef<any>;
  form: FormGroup;




  url = environment.apiDomain

  constructor(
      private langService: LanguageService,
      private modalService: NgbModal,
      private GalleryService: GalleryService,
      private ToastrService: ToastrService,
      private fb: FormBuilder
  ){
    
    this.get()
    this.form = this.fb.group({
      id: [null],
      description_ka: '',
      description_en: '',
      description_ru: '',
      link: '',
      btn_ka: '',
      btn_en: '',
      btn_ru: '',
      tmp: '',
      image: null,
    });
  }

  get(){
    this.load = true
    this.GalleryService.get().subscribe(
      (res: any) => {
        this.load = false
        this.error = false
        this.data = res
        console.log(this.data)
      },
      (error: any) => {
        this.error = true
        this.load = false
      }
    )
  }
    
 add(){
    this.isEdit = false
    this.form.reset({
      id: null,
      description_ka: '',
      description_en: '',
      description_ru: '',
      link: '',
      btn_ka: '',
      btn_en: '',
      btn_ru: '',
      image: null,
      tmp: 'left'
    });

    this.modalService.open(this.formModalTemplate, { size: 'lg' });
  }

  edit(item: any){
    this.isEdit = true
    console.log(item)
    this.form.patchValue({
      id: item.id || null,
      description_ka: item.description_ka,
      description_en: item.description_en,
      description_ru: item.description_ru || null,
      btn_ka: item.btn_ka || null,
      btn_en: item.btn_en || null,
      btn_ru: item.btn_ru || null,
      link: item.link || null,
      image: item.image || null,
      tmp: item.tmp || null,
     
    });
    this.modalService.open(this.formModalTemplate, { size: 'lg' })
  }

     onFileUploaded(fileName: string) {
    this.form.patchValue({ image: fileName });
  }




  drop(event: CdkDragDrop<any[]>) {
    moveItemInArray(this.data, event.previousIndex, event.currentIndex);

    const updated = this.data.map((item: any, index: number) => ({
      ...item,
      position: index + 1
    }));

    this.GalleryService.updatePositions({ items: updated }).subscribe(
      () => this.ToastrService.success('პოზიცია წარმატებით შეიცვალა'),
      () => this.ToastrService.error('მოხდა შეცდომა პოზიციის ცვლილების დროს')
    );
  }

  delete(data: any) {
    if (confirm('დარწმუნებული ხარ რომ გინდა წაშლა?')) {

      this.loadDeleteId = data.id;
      this.GalleryService.delete(data.id).subscribe({
        next: () => {
          this.ToastrService.success('წარმატებით წაიშალა');
          this.get();
          this.loadDeleteId = null;
        },
        error: (err: any) => {
          console.error(err);
          this.ToastrService.error('შეცდომა წაშლისას');
          this.loadDeleteId = null;
        }
      });

    }
  }

  save(modal: any){
    if(!this.isEdit){
      this.editBtnLoad = true
      this.GalleryService.update(this.form.value).subscribe(
        (res: any) => {
          this.editBtnLoad = false
          this.ToastrService.success('წარმატებით შეინახა')
          this.get()
        },
        () => {
          this.editBtnLoad = false
          this.ToastrService.error('მოხდა შეცდომა შენახვისას')
        }
      )
    }else {
      this.editBtnLoad = true
      this.GalleryService.store(this.form.value).subscribe(
        (res: any) => {
          this.editBtnLoad = false
          this.ToastrService.success('წარმატებით შეინახა')
          this.get()
        },
        () => {
          this.editBtnLoad = false
          this.ToastrService.error('მოხდა შეცდომა შენახვისას')
        }
      )
    }

  }



}
